module.exports = __webpack_public_path__ + "assets/filter-bb941d.svg";